const iconBoxStyle = { 
    display: 'flex', 
    flexDirection: 'column', 
    marginLeft: 2,
    marginTop: 2,
}; 

export default iconBoxStyle; 